/* -------------------------------------------------------------------------- *
 * Clicks the first agend tab *
 * -------------------------------------------------------------------------- *
 */

const settings = {
    selector: '.agenda__tabs',
};

const button = document.getElementById('js-firstDayTab');

/* ------------- *
 * Module Export *
 * ------------- */

const TabClick = {
    selector: settings.selector,

    init() {
        button.click();
    },
};

export default TabClick;
